import { FC } from 'react';
import { CardText, GoalCardItemContainer } from './GoalCardItem.styled';
import { Workflow } from '../../../../helpers/goals.types';

interface GoalCardItemProps {
  workFlow: Workflow;
  selectedAction: string;
  setSelectedAction: (selectedAction: string) => void;
}

const GoalCardItem: FC<GoalCardItemProps> = ({
  workFlow,
  selectedAction,
  setSelectedAction,
}) => {
  return (
    <GoalCardItemContainer
      selected={workFlow?.event === selectedAction}
      onClick={() => setSelectedAction(workFlow?.event)}
    >
      <CardText>{workFlow?.name}</CardText>
    </GoalCardItemContainer>
  );
};

export default GoalCardItem;
